module.exports = __webpack_public_path__ + "img/2-2.7d8b2ea6.png";